import _ from 'lodash';

import canDo from '@/utils/permissions';

export default {
  components: {
    FormActions: () => import('@/components/core/FormActions.vue'),
  },
  props: {
    resource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    submit: {
      type: Function,
      default: () => {},
    },
    destroy: {
      type: Function,
      default: () => {},
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      submitting: false,
    };
  },
  computed: {
    title() {
      let title = _.startCase(this.resourceName);
      if (this.canEdit) {
        title = `Edit ${title} Details`;
      } else if (this.canCreate) {
        title = `Create ${title}`;
      } else if (this.isReadOnly) {
        title = `View ${title} Details`;
      }
      return title;
    },
    isValid() {
      return true;
    },
    isEditing() {
      return !!this.resource.id;
    },
    canCreate() {
      return canDo(this.resourceName, 'create') && !this.isEditing;
    },
    canEdit() {
      return canDo(this.resourceName, 'update') && this.isEditing;
    },
    canDestroy() {
      return canDo(this.resourceName, 'destroy') && this.isEditing;
    },
    isReadOnly() {
      return !this.canCreate && !this.canEdit && !this.canDestroy;
    },
  },
  methods: {
    handleSubmit() {
      this.submitting = true;
      this.submit(this.resource).finally(() => {
        this.submitting = false;
      });
    },
    handleDestroy() {
      this.submitting = true;
      this.destroy(this.resource).finally(() => {
        this.submitting = false;
      });
    },
    handleCancel() {
      this.cancel();
    },
  },
};
